import type { AxiosInstance } from 'axios';
import { PERSONNEL_API_ENDPOINTS } from './endpoints';
import type {
  ApiNotificationPreferenceConfig,
  NotificationPreferencesConfigResponse,
} from './types/NotificationPreferencesApiResponse';

export type NotificationPreferencesHttpClientType = {
  getConfig: () => Promise<ReadonlyArray<ApiNotificationPreferenceConfig>>;
};

/**
 * HTTP client for the notification preferences configuration.
 *
 * @param props Configuration with HTTP client instance
 */
export const createNotificationPreferencesHttpClient = (props: {
  httpClient: AxiosInstance;
}): NotificationPreferencesHttpClientType => {
  const { httpClient } = props;

  const getConfig = async (): Promise<ReadonlyArray<ApiNotificationPreferenceConfig>> => {
    const response = await httpClient.get<NotificationPreferencesConfigResponse>(
      PERSONNEL_API_ENDPOINTS.NOTIFICATION_PREFERENCES.CONFIG,
    );
    return response.data?.data ?? [];
  };

  return { getConfig };
};
